import AuctionDetails from "../Popuplayout/AuctionDetails";
import PopupCloseButton from "../Popuplayout/PopupCloseButton";

const AuctionPopupDisplay = () => {
  return (
    <div className="w-[755px] h-[810px] border border-solid mt-10">
      <PopupCloseButton />
      <AuctionDetails/>
    </div>
  );
};

export default AuctionPopupDisplay;
